import React, { Component } from 'react'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment'
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';
const originalList = [
    { value: 'RFQ', status: false },
    { value: 'Certification/ Application Contract', status: false },
    { value: 'Contract Review Form', status: false },
    { value: 'Master Agreement', status: false },
    { value: 'Audit Team Proposal  & Confidentiality Statement', status: false },
    { value: 'Stage 1 Audit Schedule', status: false },
    { value: 'Audit Attendance Sheet', status: false },
    { value: 'Stage 1 Audit Report', status: false },
    { value: 'Review of Audit Processes- Stage 1', status: false },
    { value: 'Stage 2 Audit Schedule', status: false },
    { value: 'Opening/ Closing Meeting Checklists', status: false },
    { value: 'Audit Checklist', status: false },
    { value: 'Review of Audit Processes- Stage 2', status: false },
    { value: 'Corrective Action Report (NC’s )', status: false },
    { value: 'Customer Feedback Form', status: false },
    { value: 'Certification Board Decision', status: false },
    { value: 'Surveillance Audit Plan Matrix', status: false },
]
export default class ViewApprovalTeamLeader extends Component {

    constructor(props) {
        super(props)
        this.state = {
            //   orgCode : props.match.params.orgcode,
            //   stage2approvalteamleaderturl: "",

            reportOfapprovalteam: {
                orgCode: props.match.params.orgcode,
                stage2approvalteamleaderturl: "",

            },
            data: {},
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedProcessUrl: "",
            submitStatus: false,
            editStatus: false,
            showMessage: false,
            uploadStatus: true,
            messageforvalidation: "none",
            status: false,
            isLoading:false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    handleRoute = () => {
        window.location.href = "/" + localStorage.getItem("role") + "/approvalofteamleader/" + this.state.reportOfapprovalteam.orgCode;
    }
    componentDidMount() {
       const api = APIURL + '/api/stagetwo/get/stagetwodata/' + this.state.reportOfapprovalteam.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
        .then(res => {
                console.log("data ", res.data.response)
                if (res.data.errorCode === 0) {

                    this.setState({ data: res.data.response });
                    this.setState({ editStatus: true })
                    if (this.state.data && this.state.data.reportsauditor) {
                        console.log("Rfqdata", this.state.data.reportsauditor)
                        var dbList = this.state.data.reportsauditor
                        var tempList = originalList

                        var i = 0;
                        for (i = 0; i < dbList.length; i++) {
                            console.log("dblist", dbList[i])
                            var index = tempList.findIndex(e => e.value === dbList[i])

                            if (index >= -1) {
                                console.log("templi[i]", tempList[index])
                                tempList[index].status = true
                                // setShowList(tempList)
                                this.setState({ tempdata: tempList })

                            }
                        }
                        if (i > dbList.length) {

                            this.setState({ tempdata: tempList })

                        }
                    }
                    if (this.state.data.stage2approvalteamleaderturl) {
                        var uplodedFileName = this.state.data.stage2approvalteamleaderturl.split("/")
                        var uplodedFileNameToView = uplodedFileName[4]
                        this.setState({ uploadedProcessUrl: this.state.data.stage2approvalteamleaderturl, uploadedFileNameToshow: uplodedFileNameToView })
                        this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block", downloadbuttonStatus: "none" })
                    }
                    else if (!this.state.data.stage2approvalteamleaderturl) {
                        this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", downloadbuttonStatus: "block" })
                    }
                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);
    
                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                   // alert("if")
                    this.setState({isLoading:true})
                }
            })
    }
    handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if (file1 <= 3072) {
            S3FileUpload
                .uploadFile(file, this.state.config)
                .then(data => {
                    console.log("data s3", data)
                    var tempData = this.state.reportOfapprovalteam;
                    tempData.stage2approvalteamleaderturl = data.location
                    var docType = this.checkFileExtension(data.location)
                    var file = data.key.split("/")
                    var fileName = file[1];
                    this.setState({
                        stage2approvalteamleaderturl: tempData,
                        showFile: docType,
                        uploadStatus: false,
                        messageforvalidation: "none",
                        fileToUpload: data.location,
                        filenameToview: fileName
                    });
                })
                .catch(err => console.error(err))
        }
        else {
            this.setState({ filenameToview: "", messageforvalidation: "block" })
        }
    };
    downloadUploadPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
    }
    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }

    removeDoc = () => {
        var tempData = this.state.reportOfapprovalteam;
        tempData.stage2approvalteamleaderturl = ""
        this.setState({ reportOfapprovalteam: tempData, uploadStatus: true });
    }
    removeUplodedDoc = () => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest = {
                        "orgCode": this.state.data.orgCode,

                    }

                    axios.patch(APIURL + "/api/stagetwo/patch/stage2approvalteamleaderturl", jsonRequest)
                        .then((res) => {
                            if (res.data.errorCode === 0) {
                                this.setState({
                                    uploadDocumentStatus: "block",
                                    uploadedDocumentStatus: "none",
                                    uploadProcessUrl: "",
                                    uploadStatus: true,
                                    uploadedProcessUrl: "",
                                    editStatus: true
                                })
                            }
                            else {
                                ToastInstance('Error', 'Something Went Wrong')
                            }
                        })
                        .catch(err => {
                            ToastInstance('warning', 'Something Went Wrong..Please Try again')
                        })

                }
            })
    }

    generateReviewProcess = () => {
        return axios.get(APIURL + '/api/generatepdf/get/stage2approvalteamleaderpdf/' + this.state.reportOfapprovalteam.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.reportOfapprovalteam.orgCode + '- Approval Team Leader' + `.pdf`
                link.click()
            })


    }

    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfapprovalteam.orgCode,
            stage2approvalteamleaderturl: this.state.reportOfapprovalteam.stage2approvalteamleaderturl,
        }
        console.log("json", jsonRequest)
        axios.patch(APIURL + "/api/stagetwo/patch/stage2approvalteamleaderturl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'Approval TL Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }

    render() {


        const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfapprovalteam.stage2approvalteamleaderturl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadUploadPdf()} />
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('stage2approvalteamleaderturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                    <div className="row">
                        <div className="col-sm-12">
                            <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadUploadPdf()} />

                            <span>
                                <h6 onClick={() => this.removeDoc('stage2approvalteamleaderturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                            </span>
                        </div>
                        <div className="row">
                            <span>{this.state.filenameToview}</span>

                        </div>
                    </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "50px" }}>
                                        <div className="row">
                                            <div className="col-sm-12">

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of Client</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>


                                                </div>
                                                <div className="row  mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Address</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.address}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope </label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.scope}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Validity of Certificate</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.validityOfCertificate}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No. of Sites</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.noOfTempLoc}</p>

                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Total No. of Mandays</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.mandaysPlanned}</p>
                                                    </div>
                                                </div>
                                                <hr />

                                                {/* <div className="row ">
                                                            <div className="col-sm-6 text-dark">
                                                                <h5 className="mb-3"> List of Reports to be Sent by Auditor</h5>
                                                            </div>
                                                        </div> */}
                                                <div className="row">
                                                    <table className="table table-bordered">
                                                        <thead className="table-primary">
                                                            <tr>
                                                                <th>List of Reports to be Sent by Auditor</th>
                                                                <th>Remarks / Decision (If any)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>

                                                                    {


                                                                        this.state.tempdata && this.state.tempdata.length > 0 && this.state.tempdata.map((item, index) => {
                                                                            console.log("itemstatus", item.status);
                                                                            return (

                                                                                item.status === true ?

                                                                                    <div key={index} className="mt-5" ><p style={{ marginBottom: "-25px" }}>&nbsp;&nbsp; &#10004;&nbsp;&nbsp;{item.value}</p>&nbsp;&nbsp;&nbsp;&nbsp;

                                                                                    </div>
                                                                                    : <div key={index} className="mt-5" style={{ marginLeft: "5%" }}> {item.value}

                                                                                    </div>

                                                                            )
                                                                        })

                                                                    }

                                                                </td>

                                                                <td>

                                                                    <p className="mt-5">{this.state.data.rfqremark}</p>





                                                                    <p  className="mt-5">{this.state.data.certificationremark}</p>


                                                                    <p  className="mt-5">{this.state.data.contractreviewremark}</p>


                                                                    <p  className="mt-5">{this.state.data.masteragreementwremark}</p>


                                                                    <p  className="mt-5">{this.state.data.auditteamproposalremark}</p>


                                                                    <p>{this.state.data.stage1auditscheduleremark}</p>


                                                                    <p  className="mt-5">{this.state.data.auditattendencesheetremark}</p>


                                                                    <p  className="mt-5">{this.state.data.stage1auditreportremark}</p>


                                                                    <p  className="mt-5">{this.state.data.reviewauditprocessremark}</p>


                                                                    <p  className="mt-5">{this.state.data.stage2auditscheduleremark}</p>


                                                                    <p  className="mt-5">{this.state.data.openingandclosingremark}</p>


                                                                    <p  className="mt-5">{this.state.data.auditchecklistremark}</p>


                                                                    <p  className="mt-5">{this.state.data.stage2reviewofauditremark}</p>


                                                                    <p  className="mt-5">{this.state.data.correctiveactionremark}</p>


                                                                    <p  className="mt-5">{this.state.data.customerfeedbackremark}</p>


                                                                    <p  className="mt-5">{this.state.data.certificationboardremark}</p>


                                                                    <p  className="mt-5">{this.state.data.surveillanceauditplanremark}</p>



                                                                </td>
                                                            </tr>


                                                        </tbody>


                                                    </table>



                                                </div>
                                                <hr className="mt-2" />
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of Audit Team Leader</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.teamleaderName}</p>

                                                    </div>

                                                </div>



                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">NACE Code / ANZ-SIC code</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.nabcbcodeName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Accreditation </label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.accreditation}</p>

                                                    </div>
                                                </div>

                                                <div className="row mt-4">


                                                    <div>
                                                        <div className="row mt-4">
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Download Approval Team Leader</h5>
                                                            </div>
                                                            <div className="col-sm-4" />

                                                            <button className="btn btn-primary btn-sm col-sm-2 mb-2 ml-2" onClick={() => this.generateReviewProcess()}>Download</button>

                                                            <hr />
                                                        </div>
                                                    </div>
                                                    {
                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                            ""
                                                            :
                                                            <div style={{ display: this.state.uploadDocumentStatus }}>
                                                                <div className="row mt-4">
                                                                    <hr className="mt-4" />
                                                                    <div className="col-sm-6 text-dark ">
                                                                        <h5>Upload Approval Team Leader</h5>
                                                                    </div>
                                                                    <hr />
                                                                    <div className="row mt-5" >
                                                                        <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload Approval Team Leader</label></div>
                                                                        <div className="col-sm-6">
                                                                            <p style={{ color: "red", display: this.state.messageforvalidation }}>Please Select Size Which is less than 3 MB</p>
                                                                            {
                                                                                this.state.reportOfapprovalteam.stage2approvalteamleaderturl !== "" ?
                                                                                    <FileReviewProcess />
                                                                                    :
                                                                                    <>
                                                                                        <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                                        <br></br>

                                                                                    </>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-sm-6" />
                                                                        <div className="col-sm-4" />
                                                                        <button type="button" className="btn btn-sm btn-success col-sm-2 mb-2 mr-2" onClick={() => this.postData()} disabled={this.state.uploadStatus}>Upload</button>


                                                                    </div>

                                                                </div>

                                                            </div>
                                                    }

                                                </div>

                                                <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Uploaded Approval Team Leader</h5>
                                                        </div>
                                                        <hr />
                                                        <div className="col-sm-4">

                                                            <label className="mt-4 labelsize">
                                                                Uploaded Approval Team Leader
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadSignedPdf()} />
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        {
                                                                            localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                                ""
                                                                                :
                                                                                <span>
                                                                                    <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                </span>
                                                                        }
                                                                    </>
                                                                    :
                                                                    this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadSignedPdf()} />

                                                                            {
                                                                                localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                                    ""
                                                                                    :
                                                                                    <span>
                                                                                        <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                    </span>
                                                                            }
                                                                            <p>{this.state.uploadedFileNameToshow}</p>
                                                                        </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?

                                                        !this.state.uploadedProcessUrl ?
                                                            <>


                                                                <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>

                                                            </>

                                                            :
                                                            ""
                                                        :
                                                        ""

                                                }



                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {
                        localStorage.getItem("userRole") === "Management" || localStorage.getItem("userRole") === "Accounts" ?
                            ""
                            :
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-lg-10"></div>
                                    <div className="col-lg-2" >
                                        {
                                            this.state.editStatus ?
                                                !this.state.uploadedProcessUrl ?
                                                    <button className="btn btn-primary float-right ml-5" onClick={() => { this.handleRoute() }}>Edit</button>
                                                    :
                                                    <div></div>
                                                : ""
                                        }
                                        {/* <button type="submit" className="btn btn-primary" onClick={() => { this.handleRoute() }}>Edit</button> */}

                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        )
    }
}



